<template>
  <section class="sales-leave-self">
    <h2 class="title">Leave</h2>

    <app-spinner v-if="!loaded" />
    <div v-else-if="!status.available" class="sales-leave-self__unavailable" role="alert">
      <strong>Leave requests are unavailable.</strong>
      <div>{{ status.reason }}</div>
    </div>
    <template v-else>
      <app-cells>
        <h3 class="sales-leave-self__heading">Requests</h3>
        <app-button size="small" @click.native="$refs.requestModal.open()">Add Request</app-button>
      </app-cells>
      <sales-leave-requests-table :items="requests" @cancel="cancel" />

      <h3 class="sales-leave-self__heading">Leaves</h3>
      <sales-leave-leaves-table :items="leaves" @change="$refs.changeModal.open($event)" @cancel-leave="$refs.cancelModal.open($event, 'cancel')" @open-request="openRequest" />
      <leave-mutation-modal ref="cancelModal" name="sales-self-cancellation" :submit-request="submitCancellation" @saved="fetch" />

      <sales-leave-request-modal ref="requestModal" mode="self" name="sales-leave-self-request" @created="fetch" />
      <sales-leave-change-modal
        ref="changeModal"
        name="sales-leave-self-change"
        :submit-request="submitChange"
        :preview-request="previewChange"
        @created="fetch"
      />
    </template>
  </section>
</template>

<script>
import {
  getEmployeesSalesLeaveSelfLeaves,
  getEmployeesSalesLeaveSelfRequests,
  getEmployeesSalesLeaveSelfStatus,
  postEmployeesSalesLeaveSelfCancel,
  postEmployeesSalesLeaveSelfChangeRequest,
  postEmployeesSalesLeaveCancellation,
  postEmployeesSalesLeaveSelfPreview,
} from '@/http'
import SalesLeaveChangeModal from './SalesLeaveChangeModal'
import LeaveMutationModal from '@/views/employees/leaves/LeaveMutationModal.vue'
import SalesLeaveLeavesTable from './SalesLeaveLeavesTable'
import SalesLeaveRequestModal from './SalesLeaveRequestModal'
import SalesLeaveRequestsTable from './SalesLeaveRequestsTable'

export default {
  name: 'SalesLeaveSelfService',
  components: {
    SalesLeaveChangeModal,
    LeaveMutationModal,
    SalesLeaveLeavesTable,
    SalesLeaveRequestModal,
    SalesLeaveRequestsTable,
  },
  data() {
    return {
      loaded: false,
      status: { available: false, reason: '' },
      requests: [],
      leaves: [],
    }
  },
  created() {
    getEmployeesSalesLeaveSelfStatus()
      .then(res => {
        this.status = res.data
        return this.status.available ? this.fetch() : null
      })
      .finally(() => { this.loaded = true })
  },
  methods: {
    submitCancellation(leave, kind, payload) { return postEmployeesSalesLeaveCancellation(leave.id, payload, true) },
    fetch() {
      return Promise.all([
        getEmployeesSalesLeaveSelfRequests({ page_size: 100 }),
        getEmployeesSalesLeaveSelfLeaves({ page_size: 100 }),
      ]).then(([requests, leaves]) => {
        this.requests = requests.data.results
        this.leaves = leaves.data.results
      })
    },
    cancel(row) {
      postEmployeesSalesLeaveSelfCancel(row.id)
        .then(() => {
          this.$notify({ type: 'success', title: 'Request cancelled' })
          return this.fetch()
        })
        .catch(() => {})
    },
    submitChange(leave, payload) {
      return postEmployeesSalesLeaveSelfChangeRequest(leave.id, payload)
    },
    previewChange(leave, payload) {
      return postEmployeesSalesLeaveSelfPreview({ leave: leave.id, ...payload })
    },
    openRequest(requestId) {
      const row = this.$el.querySelector(`[data-request-id="${requestId}"]`)
      if (row) row.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
  },
}
</script>

<style lang="scss" scoped>
.sales-leave-self {
  margin-top: 24px;

  &__heading {
    margin: 16px 0 8px;
    font-weight: 500;
  }

  &__unavailable {
    padding: 12px 14px;
    border: 1px solid #f59e0b;
    border-radius: 6px;
    background: #fff8e6;
    font-size: 13px;
  }
}
</style>
